import { App, Plugin, VNode, DirectiveBinding, nextTick } from 'vue';

interface ScannedDirective {
    componentName: string;
    directiveName: string;
    directiveValue: any | null;
    fileName?: string; // Optional property to store the file name
}

const DirectiveScannerPlugin: Plugin = {
    install(app: App) {
        const scannedDirectives: ScannedDirective[] = []; // Explicitly typed array to store directives globally

        // Attach scannedDirectives to global properties for global access
        app.config.globalProperties.$scannedDirectives = scannedDirectives;

        // Register the 'scanner' directive globally
        app.directive('permission', {
            beforeMount(el, binding: DirectiveBinding, vnode: VNode) {
                nextTick(() => {
                    let componentName = 'UnnamedComponent';
                    let fileName: string | undefined;
 
                    // Attempt to retrieve component name from vnode
                    const children = vnode.children;

                    if (Array.isArray(children)) {
                        const firstChild = children[0];
                        const vnode = firstChild as any; // Temporarily bypass type checking
                        const filePath = vnode?.ctx?.type?.__file;

                        if (filePath) {
                            const relativePath = filePath.replace(/^src\/views\/Page\//, '');
                            const controllerPath = relativePath.replace(/\.vue$/, 'Controller');
                            const finalPath = `${controllerPath}/${binding.arg || 'index'}`;

                            if (window.permissions === undefined) {
                                window.permissions = [];
                            }
                            if (binding.arg !== undefined) {
                                window.permissions.push(finalPath);
                            }
                            console.log(finalPath);
                        }
                    }

                    scannedDirectives.push({
                        componentName,
                        directiveName: `v-${binding.arg || 'unknown'}`,
                        directiveValue: binding.value || null,
                        fileName, // Include the file name if available
                    });
                });
            },
        });

        // Provide a global method to retrieve the scanned directives
        app.provide('$getScannedDirectives', () => scannedDirectives);
    },
};

export default DirectiveScannerPlugin;
